import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/avatar';
import { NyxtLogo } from './NyxtLogo';
import { motion } from 'framer-motion';

// Animation constants extracted outside component to prevent re-renders
const ANIMATION_INITIAL = { opacity: 0, y: 10 };
const ANIMATION_ANIMATE = { opacity: 1, y: 0 };
const ANIMATION_TRANSITION = { duration: 0.3 };
const REMARK_PLUGINS = [remarkGfm];

export const ChatMessage = ({ message, user }) => {
  const isUser = message.role === 'user';
  
  return (
    <motion.div
      initial={ANIMATION_INITIAL}
      animate={ANIMATION_ANIMATE}
      transition={ANIMATION_TRANSITION}
      className={`flex gap-4 ${isUser ? 'flex-row-reverse' : ''}`}
    >
      {/* Avatar */}
      <div className="flex-shrink-0">
        {isUser ? (
          <Avatar className="w-8 h-8">
            <AvatarImage src={user?.picture} alt={user?.name} />
            <AvatarFallback 
              className="text-xs font-medium"
              style={{ backgroundColor: '#E2DFD8', color: '#1A1D1A' }}
            >
              {user?.name?.charAt(0)?.toUpperCase() || 'U'}
            </AvatarFallback>
          </Avatar>
        ) : (
          <div className="w-8 h-8 flex items-center justify-center">
            <NyxtLogo size={28} />
          </div>
        )}
      </div>
      
      {/* Message content */}
      <div 
        className={`flex-1 max-w-[85%] ${isUser ? 'text-right' : ''}`}
      >
        <div
          className={`
            inline-block text-left
            ${isUser 
              ? 'user-message px-4 py-3 sm:px-5 sm:py-4 shadow-sm' 
              : 'assistant-message'
            }
          `}
        >
          {isUser ? (
            <p className="text-[15px] leading-relaxed" style={{ color: '#1A1D1A' }}>
              {message.content}
            </p>
          ) : (
            <div className="markdown-content text-[15px]" style={{ color: '#1A1D1A' }}>
              <ReactMarkdown remarkPlugins={REMARK_PLUGINS}>
                {message.content}
              </ReactMarkdown>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default ChatMessage;
